import React from 'react';
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonIcon,
    IonContent
} from '@ionic/react';
import { arrowBackOutline, closeOutline } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';
import { Asset } from '@/types/types';
import { Provider, useSelector } from 'react-redux';
import { store } from '@/services/redux/store';
import MarketInfo from './MarketInfo';

interface MarketInfoPageProps {
    asset: Asset;
}

const Page: React.FC<MarketInfoPageProps> = ({ asset }) => {
    const { t } = useTranslation();
    const nav = document.querySelector("ion-nav");
    const [canGoBack, setCanGoBack] = React.useState(false);

    React.useEffect(() => {
        const checkNavigation = async () => {
            await new Promise(resolve => setTimeout(resolve, 150));
            const canGoBackResult = await nav?.canGoBack();
            if (canGoBackResult) {
                setCanGoBack(true);
            }
        };
        checkNavigation();
    }, []);

    const handleNavigation = async () => {
        const canGoBackResult = await nav?.canGoBack();
        if (canGoBackResult) {
            nav?.pop();
        }
    };

    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonButton onClick={handleNavigation} color='primary'>
                            <IonIcon
                                slot="icon-only"
                                icon={canGoBack ? arrowBackOutline : closeOutline}
                            />
                        </IonButton>
                    </IonButtons>
                    <IonTitle>{asset.name}</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent>
                <MarketInfo asset={asset} />
            </IonContent>
        </IonPage>
    );
};

const MarketInfoPage: React.FC<MarketInfoPageProps> = (props) => (
    <Provider store={store}>
        <Page {...props} />
    </Provider>
);

export default MarketInfoPage;
